// frontend/src/pages/About.js
import '../custom.css'
import React from 'react'
import { Container, Row, Col, Image, Card } from 'react-bootstrap'

const heroImg =
  'https://images.pexels.com/photos/3184425/pexels-photo-3184425.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=600&w=1200'
const teamImg =
  'https://images.pexels.com/photos/3184417/pexels-photo-3184417.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=350&w=600'

export default function About () {
  return (
    <>
      {/* Hero */}
      <section className='full-bleed py-5 bg-primary-soft text-center'>
        <Container style={{ maxWidth: 960 }}>
          <h1 className='display-5 fw-bold mb-3'>About&nbsp;Greatly Social</h1>
          <p className='lead mb-4'>
            Our mission is simple: <strong>help brands grow faster</strong> on
            every social network while saving them hours each week.
          </p>
        </Container>
      </section>

      {/* Why we exist */}
      <section className='py-5'>
        <Container fluid='lg'>
          <Row className='align-items-center g-5'>
            <Col md={6}>
              <Image src={heroImg} alt='Team planning' fluid className='shadow-card rounded-4' />
            </Col>
            <Col md={6}>
              <h2 className='fw-bold mb-3'>It started with a spreadsheet …</h2>
              <p className='text-muted fs-5'>
                Back in 2020 our founders were running social campaigns for
                multiple clients. They copied captions into spreadsheets,
                juggled approval emails, and set alarms to post manually.
              </p>
              <p className='text-muted mb-0'>
                So they built Greatly Social — an all-in-one calendar, editor,
                and analytics suite that automates the grunt work and frees
                marketers to do what they love: create.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Values */}
      <section className='py-5 bg-light'>
        <Container fluid='lg'>
          <h2 className='fw-bold text-center mb-5'>Our core values</h2>
          <Row className='g-4'>
            {[
              ['Customer-obsessed',  'We design every feature to save you time and grow your business.'],
              ['Transparent',       'Clear pricing, public roadmap, and honest communication.'],
              ['Iterate fast',      'Weekly releases driven by real-world feedback.'],
            ].map(([title, desc], i) => (
              <Col md={4} key={i}>
                <Card className='h-100 shadow-card'>
                  <Card.Body>
                    <Card.Title className='fw-semibold'>{title}</Card.Title>
                    <Card.Text className='text-muted'>{desc}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Team */}
      <section className='py-5'>
        <Container fluid='lg'>
          <Row className='align-items-center g-5 flex-md-row-reverse'>
            <Col md={6}>
              <Image src={teamImg} alt='Greatly Social team' fluid className='shadow-card rounded-4' />
            </Col>
            <Col md={6}>
              <h2 className='fw-bold mb-3'>Tiny team, global impact</h2>
              <p className='text-muted'>
                We’re a fully remote crew spanning 8 time-zones. That diversity
                fuels innovation and 24-hour support for our customers.
              </p>
              <p className='text-muted'>
                Want to join us? Check our <strong>Careers</strong> page — we’re
                always looking for talented creators and engineers.
              </p>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  )
}
